import { Helmet } from "react-helmet-async";

const SITE_URL = "https://oberyapi.com";
const DEFAULT_IMAGE = "/images/2-anasayfa/anasayfa.jpg";
const DEFAULT_TITLE = "Ober Yapı | Konya İnşaat ve Yapı Projeleri";
const DEFAULT_DESCRIPTION =
  "Konya'da kaliteli konut ve yapı projeleri üreten Ober Yapı. Ober Prestij, Vera Apartmanı ve diğer prestijli projeler.";

const toAbsoluteUrl = (value) => {
  if (!value) return `${SITE_URL}${DEFAULT_IMAGE}`;
  if (/^https?:\/\//i.test(value)) return value;
  return `${SITE_URL}${value.startsWith("/") ? value : `/${value}`}`;
};

const normalizePath = (path) => {
  if (!path || path === "/") return "/";
  return path.startsWith("/") ? path : `/${path}`;
};

const SeoMeta = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}) => {
  const normalizedPath = normalizePath(path);
  const canonicalUrl = `${SITE_URL}${normalizedPath}`;
  const imageUrl = toAbsoluteUrl(image);
  const robotsValue = noindex
    ? "noindex, nofollow"
    : "index, follow, max-image-preview:large";

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsValue} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="Ober Yapı" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SeoMeta;
